'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosAtOutline = function IoIosAtOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 25.1v-0.1h1.5l-0.2 0.5c-0.2 0.4-1 1.5-1.7 2.1s-1.4 1.1-2.2 1.5-1.7 0.8-2.5 1.1-1.8 0.3-2.7 0.3c-1.2 0-2.6-0.2-3.8-0.6s-2.3-1-3.4-1.9c-0.9-0.8-2-2.2-2.6-3.5-0.6-1.3-0.8-2.6-0.8-4.6 0-1.4 0.3-2.9 0.9-4.3 0.5-1.2 1.3-2.3 2.2-3.3s2.1-1.6 3.4-2.1c1.2-0.5 2.6-0.7 4.1-0.7 1.3 0 2.5 0.2 3.6 0.6 1.2 0.4 2.2 0.9 3.1 1.7s1.3 1.6 1.8 2.7c0.5 1 0.7 2.1 0.7 3.5 0 1.1-0.2 2.2-0.6 3.1s-0.7 1.6-1.3 2.3c-0.6 0.7-1 1.2-1.8 1.7-0.9 0.4-1.6 0.7-2.3 0.7-0.6 0-1.1-0.2-1.5-0.6-0.3-0.1-0.4-0.4-0.5-0.7-0.5 0.5-0.9 0.8-1.3 1-0.8 0.2-1.4 0.3-2.1 0.3s-1.1-0.1-1.6-0.3-0.9-0.6-1.3-1-0.7-0.8-0.9-1.4-0.4-1.1-0.4-1.7c0-0.9 0.3-1.9 0.6-2.8v-0.2c0.3-0.8 0.4-1.2 1-2 0.6-0.9 1.3-1.5 2.2-2s1.8-0.9 2.9-0.9c1 0 1.7 0.3 2.5 0.7 0.5 0.3 0.9 0.8 1.2 1.3l0.5-1.4h1.4l-3 8c-0.1 0.4-0.3 0.8-0.4 1.1s-0.1 0.6-0.1 0.8c0 0.1 0.1 0.3 0.3 0.4s0.3 0.1 0.6 0.1c0.5 0 0.9-0.1 1.6-0.5 0.6-0.3 0.9-0.7 1.5-1.3 0.4-0.7 0.7-1.1 1-2s0.5-1.8 0.5-2.7c0-1.2-0.1-2-0.5-2.8-0.5-1.1-0.8-1.8-1.5-2.4s-1.6-1.2-2.6-1.5-2.1-0.6-3.3-0.6c-1.5 0-2.7 0.2-3.7 0.7-1.2 0.5-2.1 1.1-2.9 1.9-0.9 0.8-1.5 1.8-2 2.9-0.4 1.1-0.7 2.5-0.7 3.7 0 1.7 0.1 2.8 0.6 3.9 0.4 1.1 1.3 2.4 2.2 3.2s1.8 1.4 2.9 1.8 2.4 0.5 3.6 0.5c0.8 0 1.6-0.1 2.4-0.3s1.4-0.5 2.1-0.9 1.3-0.8 1.9-1.4 1-1 1.4-1.6z m-6.9-2.1c0.3-0.4 0.6-1 0.8-1.6l1.7-4.4c-0.2-0.4-0.3-0.8-0.6-1.1-0.2-0.3-0.4-0.4-0.7-0.6-0.1 0-0.1-0.1-0.2-0.1-0.2-0.1-0.4-0.2-0.7-0.3-0.4-0.1-0.7-0.1-1-0.1-0.8 0-1.5 0.2-2.2 0.7s-1.3 1-1.8 1.7c-0.4 0.6-0.6 0.8-0.8 1.6 0 0-0.1 0.2-0.1 0.3-0.3 0.8-0.4 1.5-0.4 2.3 0 0.5 0.1 0.9 0.3 1.3s0.4 0.7 0.6 1 0.6 0.4 0.9 0.6 0.7 0.2 1.2 0.2c0.3 0 0.7 0 1.1-0.1 0.3-0.1 0.6-0.2 0.9-0.4s0.7-0.6 1-1z' })
        )
    );
};

exports.default = IoIosAtOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-at-outline.js
// module id = 2102
// module chunks = 0